import RequestAccess from './RequestAccess';

export default RequestAccess;
